import * as React from 'react';

import loadable from '@common/react/loadable/loadableSettings';

import Podium from '@commonTuna/react/components/UI/Podium/Podium';

import Header from '@app/components/UI/Header/Header';
import Footer from '@app/components/UI/Footer/Footer';
import { useReduxContext } from '@app/hooks/useReduxContext';

const FormStyle = loadable(
	() => import(/* webpackChunkName: "FormStyle" */ '@app/components/Forms/ContactUs/FormStyles'),
	{ fallback: <></> },
);

export const MainLayout: React.FC = (props) => {
	const [showPodium, setShowPodium] = React.useState(false);
	const {
		companySettings: {
			podiumToken = '087a7109-04c1-4a4e-a315-f789368a2d06',
		},
	} = useReduxContext();

	const handler = React.useCallback(() => setShowPodium(true), []);

	React.useEffect(() => {
		window.addEventListener('scroll', () => {
			handler();
			window.removeEventListener('scroll', handler);
		});
	}, []);

	return <div
		onPointerMove={handler}
		onPointerEnter={handler}
		onPointerDown={handler}
		className="content"
	>
		{showPodium ? <>
			<Podium token={podiumToken} />
			<FormStyle />
		</> : null}
		<Header />
		<div className="content">
			{props.children}
		</div>
		<Footer />
	</div>;
};
